import css from 'styled-jsx/css';

export default css`
  .popover-wrapper {
    position: relative;
  }
  .popover {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: #000000d9;
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings: 'tnum';
    position: absolute;
    border-radius: 8px;
    z-index: 1030;
    font-weight: 400;
    white-space: normal;
    text-align: left;
    cursor: auto;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    box-shadow: 0 0 8px rgb(0 0 0 / 0.5%);
    right: 0;
    top: 25px;
  }
  .popover:after {
    position: absolute;
    background: rgba(255, 255, 255, 0.01);
    content: '';
  }
  .close .popover {
    display: none;
  }

  .inner {
    background-color: #fff;
    background-clip: padding-box;
    border-radius: 8px;
    box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014,
      0 9px 28px 8px #0000000d;
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .inner {
      box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014,
        0 9px 28px 8px #0000000d;
    }
  }
  .title {
    min-width: 177px;
    min-height: 32px;
    margin: 0;
    padding: 5px 16px 4px;
    color: #000000d9;
    font-weight: 500;
    border-bottom: 1px solid #f0f0f0;
  }
  .inner-content {
    min-width: 177px;
    padding: 12px 16px;
    color: #000000d9;
  }
  .popover-link {
    position: relative;
  }
`;
